<div class="col-md-12 flexbox">
  <h2 class="col-md-4"> Gestion Référentiel </h2>
  <div class="col-md-8">
    <button class="pull-right" color="warn" mat-raised-button type="button" (click)="close()">
      <mat-icon>cancel</mat-icon> Fermer
    </button>
  </div>
</div>

<div class="col-md-12 flexbox">
  <div class="col-md-4" >
    <mat-card class="col-md-12 flexbox">
        <mat-card-title class="col-md-4" style="padding-top: 15px;">
          <h4>Société</h4>
        </mat-card-title>
        <div class="col-md-8 text-center">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Rechercher une société</mat-label>
            <input matInput (change)="onSelectedSociete($event.target.value)">
          </mat-form-field>
        </div>
        <div class="col-md-12">
          <mat-selection-list #societesSelected [multiple]="false">
            <mat-list-option *ngFor="let societe of societesTempon" [value]="societe" (click)="onChangeSociete(societesSelected.selectedOptions.selected[0].value)">
              {{societe.code + ' ' +societe.libelle}}
            </mat-list-option>
          </mat-selection-list>
        </div>
    </mat-card>
  </div>

  <div class="col-md-8">
    <mat-card class="col-md-12">
      <mat-card-title class="col-md-12">
        <h4>Fiche de la société</h4>
      </mat-card-title>
      <div class="col-md-12 text-center flexbox">
        <div class="col-md-4">
          <mat-form-field class="full-width">
            <mat-label>Code de la société</mat-label>
            <input matInput  [(ngModel)]="societe.code" disabled>
          </mat-form-field>
        </div>
        <div class="col-md-8">
          <mat-form-field class="full-width">
            <mat-label>Libelle de la société</mat-label>
            <input matInput  [(ngModel)]="societe.libelle" disabled>
          </mat-form-field>
        </div>
        
        
        <div class="col-md-4">
            <mat-form-field class="full-width">
              <mat-label>R.C.S</mat-label>
              <input matInput  [(ngModel)]="societe.rsc" disabled>
            </mat-form-field>
        </div>

        <div class="col-md-8">
          <mat-form-field class="full-width">
            <mat-label>Capital social</mat-label>
            <input matInput  [(ngModel)]="societe.capitalSocial" disabled>
          </mat-form-field>
      </div>
        <div class="col-md-4">
          <mat-form-field class="full-width">
            <mat-label>Siren</mat-label>
            <input matInput  [(ngModel)]="societe.siren" disabled>
          </mat-form-field>
      </div>
      <div class="col-md-4">
        <mat-form-field class="full-width">
          <mat-label>TVA intracommunautaire</mat-label>
          <input matInput  [(ngModel)]="societe.tvaIntraComm" disabled>
        </mat-form-field>
      </div>
      <div class="col-md-4">
        <mat-form-field class="full-width">
          <mat-label>Activité</mat-label>
          <mat-select [(value)]="societe.idActivite" disabled>
            <mat-option [value]="activite.id" *ngFor="let activite of activites">{{activite.code}} - {{activite.libelle}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    </mat-card>
    <br>
    <mat-card class="col-md-12" *ngIf="droits.length > 0">
      <mat-card-title class="col-md-12">
        <h4>Réferentiel général</h4>
      </mat-card-title>
      <div class="col-md-12 flexbox">
        <div class="col-md-3 text-center">

          <div>
            <button mat-raised-button color="primary" style="width: 100%;" (click)="navigateGeneral('/gestion-societe')">
              Société <mat-icon>open_in_browser</mat-icon>
            </button>
          </div>
          <br>
          <div>
          <button mat-raised-button color="primary" style="width: 100%;" (click)="navigateGeneral('/gestion-tva')">
            TVA <mat-icon>open_in_browser</mat-icon>
          </button>
          </div>
          <br>
          <div>
            <button mat-raised-button color="primary" style="width: 100%;" (click)="navigateGeneral('/gestion-activite')">
              Activité<mat-icon>open_in_browser</mat-icon>
            </button>
          </div>
          <br>
        </div>

        <div class="col-md-3 text-center">
          <div>
            <button mat-raised-button color="primary" style="width: 100%;" (click)="navigateGeneral('/gestion-na')">
              NA <mat-icon>open_in_browser</mat-icon>
            </button>
          </div>
          
          <br>
          <div>
            <button mat-raised-button color="primary"  style="width: 100%;" (click)="navigateGeneral('/gestion-cgCharge')">
              CGCharge <mat-icon>open_in_browser</mat-icon>
            </button>
          </div>
          <br>
          <div>
            <button mat-raised-button color="primary" style="width: 100%;" (click)="navigateGeneral('/gestion-typeComp')">
              Type de complément <mat-icon>open_in_browser</mat-icon>
            </button>
          </div>
          <br>
        </div>

        <div class="col-md-3 text-center">

          <div>
            <button mat-raised-button color="primary"  style="width: 100%;" (click)="navigateGeneral('/gestion-condRegl')">
              Condition de règlement <mat-icon>open_in_browser</mat-icon>
            </button>
          </div>
            <br>
        
          <div>
            <button mat-raised-button color="primary" style="width: 100%;" (click)="navigateGeneral('/gestion-modeRegl')">
              Mode de règlement <mat-icon>open_in_browser</mat-icon>
            </button>
          </div>
          <br>
          <div>
            <button mat-raised-button color="primary" style="width: 100%;" (click)="navigateGeneral('/gestion-destination')">
              Destination<mat-icon>open_in_browser</mat-icon>
            </button>
          </div>
          <br>
          
        </div>

        <div class="col-md-3 text-center">

          <div>
            <button mat-raised-button color="primary"  style="width: 100%;" (click)="navigateGeneral('/gestion-actualite')">
              Actualité<mat-icon>open_in_browser</mat-icon>
            </button>
          </div>
          <br>
          
        </div>

        
      </div>
    </mat-card>
    <br>
    <mat-card class="col-md-12">
      <mat-card-title class="col-md-12">
        <h4>Réferentiel par société</h4>
      </mat-card-title>
      <div class="col-md-12 flexbox">
        <div class="col-md-6 text-center" *ngIf="droitAdminSociete.length > 0">
          <div>
            <button mat-raised-button color="primary" style="width: 100%;" (click)="navigateSociete('/gestion-site')">
              Site <mat-icon>open_in_browser</mat-icon>
            </button>
          </div>
          <br>
          <div>
            <button mat-raised-button color="primary" style="width: 100%;" (click)="navigateSociete('/gestion-ca1')">
              CA1<mat-icon>open_in_browser</mat-icon>
            </button>
          </div>
          <br>
        </div>
        <!--C’est bien les droits interface et pas admin pour les périodes comptables-->
        <div class="col-md-6 text-center" *ngIf="droitAdminSociete.length > 0"> 
          <div>
            <button mat-raised-button color="primary" style="width: 100%;" (click)="navigateSociete('/gestion-comp')">
              Complément<mat-icon>open_in_browser</mat-icon>
            </button>
          </div>
          <br>
          <div> 
            <button mat-raised-button color="primary" style="width: 100%;" (click)="navigateSociete('/gestion-ca2')">
              CA2<mat-icon>open_in_browser</mat-icon>
            </button>
            
          </div>
        </div>
        <div class="col-md-6 text-center" *ngIf="hasDroitInterfaceSage">
          <div>
            <button mat-raised-button color="primary" style="width: 100%;" (click)="navigateSociete('/gestion-pediode-sage')">
              Période Comptable<mat-icon>open_in_browser</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </mat-card>
  </div>
</div>
